import axios from '../axios';
import { QuoteProof } from '../models';
import { G } from '../querystring';

declare interface getQuoteProofsResp {
    serial: string;
    quoteProofs: QuoteProof[];
    cloudFront: string;
}

export async function GetQuoteProofs() {
    const id = G().Get('id');
    if (!id) {
        throw new Error('id not found in querystring');
    }
    return axios.get<getQuoteProofsResp>(`/quotes/${id}/proofs`);
}